import { useTranslation } from 'react-i18next'

export function TalkConfirm({
  text,
  onConfirm,
  onCancel,
  light = false,
}: {
  text: string
  onConfirm: () => void
  onCancel: () => void
  light?: boolean
}) {
  const { t } = useTranslation()
  return (
    <div className={`talk-confirm ${light ? 'light' : ''}`} role="dialog" aria-modal="true">
      <div className="talk-confirm-card">
        <p>{text}</p>
        <div className="talk-confirm-actions">
          <button type="button" className="talk-orb-action send" onClick={onConfirm}>{t('delete')}</button>
          <button type="button" className="talk-orb-action discard" onClick={onCancel}>{t('cancel')}</button>
        </div>
      </div>
    </div>
  )
}
